import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { AntiBriberyAndCorruptionPolicyStatementPageContent } from "./AntiBriberyAndCorruptionPolicyStatementPageContent";
import { AntiBriberyAndCorruptionPolicyStatementPageHeading } from "./AntiBriberyAndCorruptionPolicyStatementPageHeading";
import { AntiBriberyAndCorruptionPolicyStatementNextPage } from "./AntiBriberyAndCorruptionNextPage";

export const AntiBriberyAndCorruptionPolicyStatement = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "antiBriberyCorruptionPageHeading",
      children: <AntiBriberyAndCorruptionPolicyStatementPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "antiBriberyCorruptionPageContent",
      children: <AntiBriberyAndCorruptionPolicyStatementPageContent/>
    },
    {
      label: "Next Page",
      key: "antiBriberyCorruptionNextPage",
      children: <AntiBriberyAndCorruptionPolicyStatementNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
